import React, { useContext, useCallback } from 'react';
import { FormSpy } from 'react-final-form';
import { CopyInvestorContext } from './CopyInvestorContext';
import { ReferenceArrayInput, useQuery, Loading } from 'react-admin';
import { Grid } from '@material-ui/core/';

import GridInputFilter from '../../../core/components/inputs/GridInputFilter';
import { makeStyles } from '@material-ui/core';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';

const useStyles = makeStyles({
  loading: {
    height: 'calc(100vh - 230px)'
  }
});

const validateInvestors = (value, allValues, props, field) => {
  if (Array.isArray(value) && value.length < 1) {
    return 'At least one Investor must be selected';
  }
  return undefined;
};

const InvestorGrid = props => {
  const { relatedInvestorIds } = props;
  const classes = useStyles();
  let { data, loading } = useQuery({
    type: 'getManyReference',
    resource: 'fundinvestors',
    payload: {
      target: 'fundId',
      id: props.fundId,
      sort: {
        order: 'ASC'
      }
    }
  });
  if (loading) return <Loading className={classes.loading} />;
  const filter = choices => {
    //filter only available investors and ones that are not already matched with fundId
    return choices.filter(
      item =>
        data.findIndex(obj => obj.investorId === item.id) !== -1 &&
        relatedInvestorIds.indexOf(item.id) === -1
    );
  };

  return (
    <div>
      <Grid container spacing={1}>
        <ReferenceArrayInput
          perPage={-1}
          sort={{ field: 'name', order: 'ASC' }}
          validate={validateInvestors}
          filter={{
            orphanVisibility: 'ALL_VISIBLE'
          }}
          label="Search Investors"
          optionTextLabel="Investor Name"
          optionValueLabel="Investor ID"
          resource="investors"
          reference="investors"
          source="investors"
        >
          <GridInputFilter
            choicesToExclude={data}
            filter={filter}
            height={'calc(80vh - 180px)'}
          />
        </ReferenceArrayInput>
      </Grid>
    </div>
  );
};

const SelectInvestorsStep = props => {
  const { fundId, onSubmitEnd, relatedInvestorIds } = props;
  const { investorContext, setInvestorsContext } = useContext(
    CopyInvestorContext
  );

  const setFundInvestors = useCallback(
    values => {
      setInvestorsContext({
        ...investorContext,
        currentForm: undefined,
        investors: values.investors
      });
      onSubmitEnd(values);
    },
    [investorContext, onSubmitEnd, setInvestorsContext]
  );

  return (
    <CustomSimpleForm
      save={setFundInvestors}
      initialValues={{
        investors: investorContext.investors || []
      }}
      toolbar={null}
      // We override the redux-form name to avoid collision with the react-admin main form
      resource="fundinvestors"
      variant="standard"
      margin="normal"
    >
      <FormSpy>
        {formprops => {
          if (investorContext.currentForm === undefined) {
            setInvestorsContext({
              ...investorContext,
              currentForm: formprops.form
            });
          }

          return (
            <InvestorGrid
              {...props}
              creation
              fundId={fundId}
              relatedInvestorIds={relatedInvestorIds}
              label="Search Investor"
            />
          );
        }}
      </FormSpy>
    </CustomSimpleForm>
  );
};

export default SelectInvestorsStep;
